<template>
<section class="bulk-import-page">
    <div class="bulk-import-box" v-if="!hasResult && !lastPage">
        <el-image :src="centerImage"></el-image>
        <template v-if="!isUploading">
            <div class="bulk-import-operate">
                <input type="file" @change="uploadFile" hidden id="upload-file"
                    accept=".zip,.rar,application/zip,application/x-zip-compressed,application/x-rar-compressed">
                <el-button type="primary" @click="chooseFile">
                    点击上传<i class="el-icon-upload2"></i></el-button>
                <el-button type="primary" plain @click="downloadFiles">
                    模板下载<i class="el-icon-document-copy"></i></el-button>
            </div>
            <div class="bulk-import-tip">支持上传格式为.zip，且可以支持多个压缩包文件，总大小不大于1G</div>
        </template>
        <template v-else>
            <el-progress :percentage="uploadProgress"></el-progress>
            <div class="bulk-import-tip">上传解析中，请耐心等待...</div>
        </template>
    </div>

    <div class="bulk-import-result" v-else-if="hasResult && !lastPage">
        <el-table :data="uploadReturnData" max-height="600" v-loading="isResolve"
            @selection-change="selectProduct">
            <el-table-column type="selection" width="60" align="center"></el-table-column>
            <el-table-column label="商品图片" width="160">
                <template slot-scope="scope">
                    <!-- <el-image :src="scope.row.goodsThumbnail"></el-image> -->
                    <img :src="scope.row.goodsThumbnail"/>
                </template>
            </el-table-column>
            <el-table-column prop="goodsName" label="商品名称"></el-table-column>
            <el-table-column label="商品类型" align="center">
                <template slot-scope="scope">
                    {{ getGoodsCategory(scope.row.goodsCategory) }}
                </template>
            </el-table-column>
            <el-table-column prop="parentSatelliteCategoryName" label="卫星分类" align="center"></el-table-column>
            <el-table-column prop="satelliteCategoryName" label="卫星细分类" align="center"></el-table-column>
            <el-table-column label="商品价格" align="center">
                <template slot-scope="scope">
                    ￥{{ getGoodsPrice(scope.row.goodsPriceType, scope.row.goodsPrice) }}
                </template>
            </el-table-column>
            <el-table-column prop="goodsDescribe" label="商品描述"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-link type="primary" @click="getDetail(scope.row)">详情</el-link>
                    <el-link type="danger" @click="deleteUpload(scope.row)" style="margin-left: 12px;">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="bulk-import-result-operate">
            <div class="bulk-result-operate-left">
                <el-button type="danger" round @click="bulkDelete" size="small">批量删除</el-button>
            </div>
            <el-button type="primary" @click="nextStep">下一步</el-button>
        </div>

        <el-dialog :visible.sync="detailModal" width="50%">
            <template slot="title">
                <div class="modal-title">详细信息</div>
            </template>
            <div class="modal-content">
                <div class="modal-content-item">
                    <div class="modal-item-title"><i class="el-icon-finished"></i>影像基础数据</div>
                    <div class="modal-item-content">
                        <div class="modal-info-item" v-for="item in modalBasicData">
                            <div class="modal-info-item-title">{{ item.label }}</div>
                            <div class="modal-info-item-data">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-content-item">
                    <div class="modal-item-title"><i class="el-icon-finished"></i>系统生产参数</div>
                    <div class="modal-item-content">
                        <div class="modal-info-item" v-for="item in modalProductData">
                            <div class="modal-info-item-title">{{ item.label }}</div>
                            <div class="modal-info-item-data">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
    <div class="import-delivery" v-else-if="lastPage">
        <div class="import-delivery-box">
            <div class="import-delivery-item">
                <div class="import-delivery-item-title">计费方式</div>
                <div class="import-delivery-item-content">
                    <el-radio-group v-model="chargingType">
                        <el-radio :label="1">按次计费</el-radio>
                        <el-radio :label="2">按周期计费</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="import-delivery-item">
                <div class="import-delivery-item-title">交付方式</div>
                <div class="import-delivery-item-content">
                    <el-radio-group v-model="deliveryType">
                        <!-- <el-radio :label="1">线上交易</el-radio> -->
                        <el-radio :label="2">线下预约交易</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="import-delivery-item">
                <div class="import-delivery-item-title">交付时间</div>
                <div class="import-delivery-item-content">
                    <el-radio-group v-model="isDay">
                        <el-radio :label="false">实时</el-radio>
                        <el-radio :label="true">天</el-radio>
                        <el-input v-model="deliveryDate" v-show="isDay" style="width: 80px;"
                            type="number" @change="watchNumberInput"/>
                    </el-radio-group>
                </div>
            </div>
            <div class="import-delivery-item">
                <div class="import-delivery-item-title">截止日期</div>
                <div class="import-delivery-item-content">
                    <el-date-picker v-model="endDate" value-format="yyyy-MM-dd 00:00:00" type="date"
                        placeholder="选择日期" style="margin-right: 12px;" :disabled="hasDeadline" />
                    <el-checkbox v-model="hasDeadline">长期有效</el-checkbox>
                </div>
            </div>
            <!-- <div class="import-delivery-item">
                <div class="import-delivery-item-title">数据下载地址</div>
                <div class="import-delivery-item-content">
                    <el-input v-model="dataDownloadUrl" placeholder="请输入下载地址"
                        style="width: 100%;"></el-input>
                </div>
            </div> -->
            <div class="import-delivery-operate">
                <el-button plain @click="backPrev">上一步</el-button>
                <el-button type="primary" plain @click="submitDelivery">确认提交</el-button>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import centerImage from '@/assets/imgs/sellerCenter/bulk-import.png'
export default {
    name: 'BulkImport',
    components: {},
    data() {
        return {
            centerImage,
            hasResult: false,
            isUploading: false,
            uploadProgress: 0,
            isResolve: false,
            uploadId: null,
            uploadReturnData: [],
            selectedProduct: [],
            detailModal: false,
            modalBasicData: [],
            modalProductData: [],
            shortInterval: null,
            longInterval: null,
            lastPage: false,


            endDate: null,
            chargingType: 1,
            deliveryType: 2,
            isDay: false,
            hasDeadline: true,
            deliveryDate: 1,
            dataDownloadUrl: null
        }
    },
    beforeDestroy(){
        clearInterval(this.shortInterval)
        clearInterval(this.longInterval)
    },
    computed: {
        getGoodsCategory() {
            return type => {
                switch(type){
                    case 1: return '影像数据'
                    case 2: return '数据产品'
                    case 3: return '软件产品'
                    case 4: return '其他产品'
                }
            }
        },
        getGoodsPrice() {
            return (type, price) => {
                if(type === 1) {
                    return Number(price.toFixed(2)) || 0
                }else if(type === 2) {
                    return '价格面议'
                }else if(type === 3) {
                    return '免费'
                }
            }
        }
    },
    methods: {
        chooseFile() {
            document.getElementById('upload-file').click()
        },
        uploadFile(el) {
            let file = el.target.files[0]
            if(file.size > 1073741824) {
                this.$message.error('文件超过1G，请重新选择')
                return false
            }else {
                let formData = new FormData()
                formData.append('file', file)
                this.isUploading = true
                this.$http.postFile(this.$const.common.importBulkProducts, formData, (progress) => {
                    this.uploadProgress = Number((progress.loaded / progress.total).toFixed(2))
                }).then(res => {
                    this.isUploading = false
                    console.log(res)
                    if(res.code === 200) {
                        this.$message.success('文件上传中！请稍候...')
                        this.hasResult = true
                        this.isResolve = true
                        this.uploadId = res.data.batchId
                        let requestCount = 0
                        this.shortInterval = setInterval(() => {
                            if(++requestCount > 3) {
                                clearInterval(this.shortInterval)
                                this.longInterval = setInterval(() => {
                                    this.requestUploadData()
                                }, 15000);
                            }
                            this.requestUploadData()
                        }, 5000)
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        },
        downloadFiles() {
            // window.open('/files/模板参数.zip', '_blank')
            window.open('/dtpc/files/模板参数.zip', '_blank')
        },
        requestUploadData() {
            // 轮询请求
            this.$http.get(this.$const.common.getUploadData + this.uploadId).then(res => {
                console.log(res)
                if(res.code === 200) {
                    if(res.data.goodsBatch.status === 1 && res.data.list) {
                        this.uploadReturnData = res.data.list
                        this.isResolve = false
                        clearInterval(this.shortInterval)
                        clearInterval(this.longInterval)
                    }else if(res.data.goodsBatch.status === 3) {
                        this.$message.error('文件上传失败！')
                        this.isResolve = false
                        clearInterval(this.shortInterval)
                        clearInterval(this.longInterval)
                    }
                }
            }).catch(error => {
                console.log(error)
            })
        },
        selectProduct(val){
            this.selectedProduct = val
        },
        getDetail(product){
            this.detailModal = true
            this.modalBasicData = [
                {label: '卫星', value: product.basicImageInfo.satellite}, {label: '传感器', value: product.basicImageInfo.sensor},
                {label: '采集时间', value: product.basicImageInfo.acquisitionTime}, {label: '轨道圈号', value: product.basicImageInfo.pathwayNumber},
                {label: '产品起始时间', value: product.basicImageInfo.productStartTime}, {label: '产品间行时间', value: product.basicImageInfo.productMiddleTime},
                {label: '产品结束时间', value: product.basicImageInfo.productEndTime}, {label: '景Path/Row', value: product.basicImageInfo.scene},
                {label: '星下点Path/Row', value: product.basicImageInfo.substar}, {label: '接收站', value: product.basicImageInfo.acceptingStation},
                {label: '左上角经度', value: product.basicImageInfo.upperLeftLongitude}, {label: '左上角纬度', value: product.basicImageInfo.upperLeftLatitude},
                {label: '右上角经度', value: product.basicImageInfo.upperRightLongitude},{label: '右上角纬度', value: product.basicImageInfo.upperRightLatitude},
                {label: '左下角经度', value: product.basicImageInfo.lowerLeftLongitude},{label: '左下角纬度', value: product.basicImageInfo.lowerLeftLatitude},
                {label: '右下角经度', value: product.basicImageInfo.lowerRightLongitude},{label: '右下角纬度', value: product.basicImageInfo.lowerRightLatitude},
                {label: '景中心纬度', value: product.basicImageInfo.centerLatitude},{label: '景中心经度', value: product.basicImageInfo.centerLongitude}
            ]
            this.modalProductData = [
                {label: '云覆盖量', value: product.systemProductParam.cloudCover},{label: 'DEM数据来源', value: product.systemProductParam.demDataSource},
                {label: '地球模型', value: product.systemProductParam.earthModel},{label: '椭球模型', value: product.systemProductParam.ellipsoidModel},
                {label: '浮动比例', value: product.systemProductParam.floatingRate},{label: '地图投影', value: product.systemProductParam.mapProjection},
                {label: '原始数据条带号', value: product.systemProductParam.originalDataStripNumber},{label: '产品大小（单位MB）', value: product.systemProductParam.productDataSize},
                {label: '生产日期', value: product.systemProductParam.productDate},{label: '产品分辨率', value: product.systemProductParam.productDistinguishability},
                {label: '产品格式', value: product.systemProductParam.productFormat},{label: '产品级别', value: product.systemProductParam.productLevel},
                {label: '产品序列号', value: product.systemProductParam.productSerialNumber},{label: '产品谱段', value: product.systemProductParam.productSpectralCoverage},
                {label: '产品类型', value: product.systemProductParam.productType},{label: '产品宽度', value: product.systemProductParam.productWidth},
                {label: '投影带号', value: product.systemProductParam.projectionNumber},{label: '辐射校正方法', value: product.systemProductParam.radiometricCorrectionMethod},
                {label: '重采样方法', value: product.systemProductParam.resamplingMethod},{label: '连续景数', value: product.systemProductParam.sceneNumber},
                {label: '景序列号', value: product.systemProductParam.sceneSerialNumber}
            ]
        },
        deleteUpload(product){
            this.selectedProduct = [product]
            this.bulkDelete()
        },
        bulkDelete() {
            // 批量删除
            let deleteList = this.selectedProduct.map(item => {
                return item.id
            })
            if(deleteList.length) {
                this.$http.post(this.$const.common.bulkDeleteUpload, deleteList).then(res => {
                    if(res.code === 200 && res.data) {
                        this.$message.success('删除成功')
                        this.requestUploadData()
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        },
        nextStep() {
            // 下一步
            if(this.uploadReturnData.length) {
                this.lastPage = true
            }else {
                this.$message.error('无商品，即将返回！')
                setTimeout(() => { location.reload() }, 500)
            }
        },
        watchNumberInput(val){
            if(val < 0) {
                this.deliveryDate = 1
                this.$message.error('交付时间不能为负')
            }else if(val == null || val == '') {
                this.deliveryDate = 1
            }
        },
        backPrev() {
            this.hasResult = true
            this.lastPage = false
            this.requestUploadData()
        },
        submitDelivery() {
            this.$http.post(this.$const.common.publishUploadProduct, {
                batchId: this.uploadId,
                chargingType: this.chargingType,
                deliveryType: this.deliveryType,
                deliveryDate: this.isDay ? this.deliveryDate : null,
                endDate: this.endDate || null,
                dataDownloadUrl: this.dataDownloadUrl,
            }).then(res => {
                if(res.code === 200 && res.data) {
                    this.$message.success('导入成功！正在返回中...')
                    setTimeout(() => {
                        this.$router.push({
                            name: 'SellerCenter',
                            query: {
                                type: 'CommodityList'
                            }
                        })
                    }, 500)
                }
            }).catch(error => {
                console.log(error)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.bulk-import-page {
    width: 100%;
    overflow: hidden;

    > .bulk-import-box {
        margin-top: 10vh;
        text-align: center;
        
        > .el-image {
            max-width: 300px;
            max-height: 240px;
        }
        > .bulk-import-operate {
            margin-top: 40px;

            > .el-button {

                i {
                    margin-left: 12px;
                }
            }
        }
        > .bulk-import-tip {
            margin-top: 20px;
            color: #999999;
            font-size: 14px;
        }
        > .el-progress {
            width: 600px;
            margin: 0 auto;
            margin-top: 24px;
        }
    }
    > .bulk-import-result {

        > .el-table {

            ::v-deep .el-table__header {
                th {
                    background-color: #DAE0F0;
                    color: black;
                }
            }
            .el-table__body {
                .cell{

                    > img {
                        width: 120px;
                        height: 120px;
                        object-fit: cover;
                    }
                }
            }
        }
        > .bulk-import-result-operate {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            padding-top: 12px;

            > .bulk-result-operate-left {
                margin-left: 16px;
            }
        }
        > .el-dialog__wrapper {
            .modal-title {
                padding-left: 20px;
                border-left: 5px solid #2569F2;
                font-size: 20px;
                font-weight: 700;
            }
            .modal-content {
                padding: 0 20px;

                > .modal-content-item {
                    margin-bottom: 24px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                    
                    > .modal-item-title {
                        color: #2569F2;
                        font-size: 16px;
                        > i {
                            margin-right: 12px;
                        }
                    }
                    > .modal-item-content {
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: 16px;

                        > .modal-info-item {
                            flex: 0 0 33%;
                            display: flex;

                            > .modal-info-item-title {
                                flex: 3;
                                padding: 10px;
                                background-color: #F5F5F5;
                            }
                            > .modal-info-item-data {
                                flex: 4;
                                padding: 10px;
                                background-color: rgba($color: #2569F2, $alpha: .05);
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }
    }
    > .import-delivery {

        > .import-delivery-box {
            width: 600px;
            margin: 0 auto;
            margin-top: 16vh;

            > .import-delivery-item {
                display: flex;
                align-items: center;
                margin: 24px 0;

                > .import-delivery-item-title {
                    width: 120px;
                }
                > .import-delivery-item-content{
                    flex: 1;
                }
            }
            > .import-delivery-operate {
                margin-top: 52px;
                text-align: center;
            }
        }
    }
}
</style>